import React from 'react';

import BenchlingQuery from 'graphql-client/BenchlingQuery';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {CenteredSpinner} from 'ui-library/Spinner';

import {
  ContainerRelevantItemsQuery,
  ContainerRelevantItemsQueryVariables,
} from './__generated/ContainerRelevantItemsQuery';
import ContainerPresentationalRelevantItemsSection from './ContainerPresentationalRelevantItemsSection';
import {CONTAINER_RELEVANT_ITEMS_QUERY} from './ContainerRelevantItemsGraphQL';

interface ContainerRelevantItemsSectionProps {
  containerId: string;
}

export default function ContainerRelevantItemsSection({
  containerId,
}: ContainerRelevantItemsSectionProps): JSX.Element {
  return (
    <BenchlingQuery<ContainerRelevantItemsQuery, ContainerRelevantItemsQueryVariables>
      query={CONTAINER_RELEVANT_ITEMS_QUERY}
      variables={{containerId}}
      renderLoading={() => <CenteredSpinner />}
    >
      {(data) => {
        if (data == null || isInaccessible(data.container)) {
          return 'No access'; // Shouldn't get here because container page is already guarded by permissions, but just in case :)
        }
        return (
          <ContainerPresentationalRelevantItemsSection
            relevantItemsGraphQL={data.container.relevantItems}
            containerId={containerId}
          />
        );
      }}
    </BenchlingQuery>
  );
}
